<template functional>
  <div>
    <span :class="$options.changeColor(props)">
      {{ props.rowValue }}
    </span>
  </div>
</template>

<script>
import { formatMonto } from "@/utils";
export default {
  formatMonto,
  name: "colorIncentory",
  changeColor(props) {
    // console.log("klok",props)
    return props.row.FullQuanti >= props.row.MiOrderQ &&
      props.row.FullQuanti <= props.row.Minven
      ? "Verde"
      : props.row.FullQuanti < props.row.MiOrderQ
      ? "Rojo"
      : props.row.FullQuanti > props.row.Minven
      ? "Azul"
      : null;
  }
};
</script>

<style scoped>
.Rojo {
  color: #c71d10;
}

.Verde {
  color: rgb(0, 128, 0);
}
.Azul {
  color: blue;
}
</style>
